import React from 'react';
import ReactDOM from 'react-dom/client';
import ClearanceCalculations from './ClearanceCalculations';

const $root: HTMLElement | null = document.getElementById(
	'timken-tool-bearing-clearance-calculations',
);

if ( $root ) {
	ReactDOM.createRoot( $root ).render(
		<React.StrictMode>
			<ClearanceCalculations />
		</React.StrictMode>
	);
}
